import React from "react"
import PropTypes from "prop-types"
import * as Yup from "yup"
import {Formik, Form, Field } from "formik"

import {TextInput, SelectInput, NumberInput, TextAreaInput, ReCAPTCHAInput} from "./index"
import {Button, ErrorMessage} from "../styled"

import {contactReasons, addOptionalReCaptchaSchema} from "../../utils/FormUtils"

export const ContactForm = ({onSubmit, recaptchaVisible}) => {
  const validPhoneLengthRegEx = /(^$)|(^\d{10}$)/
  const initialValues = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    trackingNumber: "",
    contactReason: "",
    additionalComments: "",
    recaptcha: ""
  }

  const constantSchema = {
    firstName: Yup.string().required("First Name is required").min(2, "First Name is invalid"),
    lastName: Yup.string().required("Last Name is required").min(2, "Last Name is invalid"),
    email: Yup.string().email("Email is invalid").required("Email address is required"),
    trackingNumber: Yup.string(),
    contactReason: Yup.string().required("Contact Reason is required"),
    additionalComments: Yup.string(),
  }

  const validationSchema = addOptionalReCaptchaSchema(constantSchema, recaptchaVisible)


  const validatePhone = (value) => {
    let error
    if (!value) {
      error = "T-Mobile phone number is required"
    }

    if (value && !value.replace(/[^a-z0-9]/g, "").match(validPhoneLengthRegEx)) {
      error = "T-Mobile phone number must be 10 digits"
    }

    /* eslint-disable eqeqeq */
    // we need double equal here
    if (value && (value.charAt(0) == 1 || value.charAt(0) == 0)) {
      error = "T-Mobile phone number cannot start with 0 or 1"
    }

    return error
  }

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({isSubmitting,status}) => (
        <Form>
          <div><p className="small">Fields marked with * are required</p></div>
          <div className="row">
            <div className="form-group col-md-6">
              <Field name="firstName" component={TextInput} type="text" placeholder="First Name*"></Field>
            </div>
            <div className="form-group col-md-6">
              <Field name="lastName" component={TextInput} type="text" placeholder="Last Name*"></Field>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6">
              <Field name="phoneNumber" component={NumberInput} validate={validatePhone} type="tel" placeholder="T-Mobile phone number*" maxLength={14}></Field>
            </div>
            <div className="form-group col-md-6">
              <Field name="email" component={TextInput} type="email" placeholder="Email*"></Field>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6">
              <Field name="trackingNumber" component={TextInput} type="text" placeholder="Tracking Number"></Field>
            </div>
            <div className="form-group col-md-6">
              <Field name="contactReason" component={SelectInput} disabled={false}>
                <option value="">Select a Contact Reason*</option>
                {contactReasons.map((reason) => {
                  return (<option value={reason} key={reason}>{reason}</option>)
                })}
              </Field>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-12">
              <Field name="additionalComments" component={TextAreaInput} placeholder="Additional Comments" rows="3"></Field>
            </div>
          </div>
          {recaptchaVisible &&
            <div className="row">
              <div className="col-md-12">
                <Field name="recaptcha" component={ReCAPTCHAInput} />
              </div>
            </div>
          }
          <div className="mt-3 text-center text-md-left">
            <Button type="submit" className="btn" id="btnSubmit" primary disabled={isSubmitting}>Submit</Button>
            {status && status.formError && <ErrorMessage>{status.formError}</ErrorMessage>}
          </div>
        </Form>)}
    </Formik>
  )
}

ContactForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  recaptchaVisible: PropTypes.bool.isRequired
}
